import { LayoutDashboard, Package, Wrench, AppWindow } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { SysAppDto } from '@/app/services/api/sysAppService';

/**
 * Canonical icon mapping for SysApp tiles across workspace surfaces.
 * Used by MobileWorkspaceHome main grid, AppShell drawer, and RecentsSection
 * so a given app renders with the same icon everywhere.
 */
export function iconForApp(app: SysAppDto): LucideIcon {
  const isApp = app.classification === 'app';
  const isTenant = app.accessType === 'private';
  return isApp
    ? isTenant ? LayoutDashboard : Package
    : isTenant ? Wrench : AppWindow;
}
